import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoovCommonModule } from '../moov-common/moov-common.module';
import { ChatViewComponent } from './chat-view/chat-view.component';
import { ChatUserPromptComponent } from './chat-user-prompt/chat-user-prompt.component';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ChatCarouselComponent } from './chat-carousel/chat-carousel.component';
import { ChatViewDeleteConfirmationDialogComponent } from './chat-view-delete-confirmation-dialog/chat-view-delete-confirmation-dialog.component';
import { AudioPlayerControlerComponent } from './audio-player-controler/audio-player-controler.component';
import { FormsModule } from '@angular/forms';
import { AudioCaptureComponent } from './audio-capture/audio-capture.component';
import { MatChipsModule } from '@angular/material/chips';
import {MatBadgeModule} from '@angular/material/badge';
import { StructuredProcessViewComponent } from './structured-process-view/structured-process-view.component';
import { StructuredProccessControllerComponent } from './structured-proccess-controller/structured-proccess-controller.component';
import { StructuredProcessChatComponent } from './structured-process-chat/structured-process-chat.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { StructuredProcessArtifactViewWorkplanComponent } from './structured-process-artifact-view-workplan/structured-process-artifact-view-workplan.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDividerModule } from '@angular/material/divider';
import { StructuredProcessIntroComponentComponent } from './structured-process-intro-component/structured-process-intro-component.component';
import { StructuredProcessCompentenciesContainerComponent } from './structured-process-compentencies-container/structured-process-compentencies-container.component';
import { StructuredProcessIntroConsentComponent } from './structured-process-intro-consent/structured-process-intro-consent.component';
import { EmbeddedDiscoveryChatComponent } from './embedded-discovery-chat/embedded-discovery-chat.component';
import { EmbeddedDiscoveryWizardComponent } from './embedded-discovery-wizard/embedded-discovery-wizard.component';
import { StructuredProcessExternalInfoComponent } from './structured-process-external-info/structured-process-external-info.component';
import { DiscoveryProcessModule } from '../discovery-process/discovery-process.module';

@NgModule({
  declarations: [
    ChatViewComponent,
    ChatMessageComponent,
    ChatUserPromptComponent,
    ChatCarouselComponent,
    ChatViewDeleteConfirmationDialogComponent,
    AudioPlayerControlerComponent,
    AudioCaptureComponent,
    StructuredProcessViewComponent,
    StructuredProccessControllerComponent,
    StructuredProcessChatComponent,
    StructuredProcessArtifactViewWorkplanComponent,
    StructuredProcessIntroComponentComponent,
    StructuredProcessCompentenciesContainerComponent,
    StructuredProcessIntroConsentComponent,
    EmbeddedDiscoveryChatComponent,
    EmbeddedDiscoveryWizardComponent,
    StructuredProcessExternalInfoComponent,
  ],
  imports: [
    CommonModule,
    MoovCommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatListModule,
    MatSidenavModule,
    MatChipsModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatToolbarModule, 
    MatProgressBarModule,
    MatExpansionModule, 
    MatCheckboxModule, 
    MatDatepickerModule,
    MatNativeDateModule, 
    MatSnackBarModule,
    MatCardModule,
    DragDropModule,
    ClipboardModule,
    MatDividerModule,
    DiscoveryProcessModule
  ]
})
export class ChatViewModule { }
